<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px 16px 0px 16px !important;" class="todoindex" :style="conheight">
        <!-- <span class="todotitle">待办事项</span> -->
    <div class="todomenu">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="集团总部公告" name="isChildUpdate1">
                <newsList classifyId="1284067866026577920" v-if="isChildUpdate1"></newsList>
            </el-tab-pane>
            <el-tab-pane label="分公司公告" name="isChildUpdate2">
                <newsList classifyId="1291565278643228672" v-if="isChildUpdate2"></newsList>
            </el-tab-pane>
            <el-tab-pane label="规章制度" name="isChildUpdate3">
                <newsList classifyId="1291565231734132736" v-if="isChildUpdate3"></newsList>
            </el-tab-pane>
            <el-tab-pane label="企业文化台&曝光台" name="isChildUpdate4">
                <newsList classifyId="1291565532486701056" v-if="isChildUpdate4"></newsList>
            </el-tab-pane>
            <el-tab-pane label="培训信息" name="isChildUpdate5">
                <newsList classifyId="1284026697187987456" v-if="isChildUpdate5"></newsList>
            </el-tab-pane>
            <el-tab-pane label="招聘信息" name="isChildUpdate6">
                <newsList classifyId="1297010042469486592" v-if="isChildUpdate6"></newsList>
            </el-tab-pane>
            <el-tab-pane label="新品发布" name="isChildUpdate7">
                <newsList classifyId="1291565574131945472" v-if="isChildUpdate7"></newsList>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>


<script>
import newsList from "@/components/news/newsList.vue";
import completeView from "@/components/flow/completeView.vue";
  export default {
    name: "haiyaNews",
     components: {
        newsList,
        completeView
    },
    data() {
      return {
        activeName: 'isChildUpdate1',
         isChildUpdate1:true,
         isChildUpdate2:false,
         isChildUpdate3:false,
         isChildUpdate4:false,
         isChildUpdate5:false,
         isChildUpdate6:false,
         isChildUpdate7:false,
         conheight: { height: window.innerHeight  + "px"},
         src:window.location.origin 
      };
    },
    methods: {
        handleClick(tab, event) {
            if(tab.name == "isChildUpdate1") {
                this.isChildUpdate1 = true;

                this.isChildUpdate2=false;
                this.isChildUpdate3=false;
                this.isChildUpdate4=false;
                this.isChildUpdate5=false;
                this.isChildUpdate6=false;
                this.isChildUpdate7=false;
            }else if (tab.name == "isChildUpdate2"){
                this.isChildUpdate2 = true;

                this.isChildUpdate1=false;
                this.isChildUpdate3=false;
                this.isChildUpdate4=false;
                this.isChildUpdate5=false;
                this.isChildUpdate6=false;
                this.isChildUpdate7=false;
            }else if (tab.name == "isChildUpdate3"){
                this.isChildUpdate3 = true;

                this.isChildUpdate1=false;
                this.isChildUpdate2=false;
                this.isChildUpdate4=false;
                this.isChildUpdate5=false;
                this.isChildUpdate6=false;
                this.isChildUpdate7=false;
            }else if (tab.name == "isChildUpdate4"){
                this.isChildUpdate4 = true;

                this.isChildUpdate1=false;
                this.isChildUpdate2=false;
                this.isChildUpdate3=false;
                this.isChildUpdate5=false;
                this.isChildUpdate6=false;
                this.isChildUpdate7=false;
            }else if (tab.name == "isChildUpdate5"){
                this.isChildUpdate5 = true;

                this.isChildUpdate1=false;
                this.isChildUpdate2=false;
                this.isChildUpdate3=false;
                this.isChildUpdate4=false;
                this.isChildUpdate6=false;
                this.isChildUpdate7=false;
            }else if (tab.name == "isChildUpdate6"){
                this.isChildUpdate6 = true;

                this.isChildUpdate1=false;
                this.isChildUpdate2=false;
                this.isChildUpdate3=false;
                this.isChildUpdate4=false;
                this.isChildUpdate5=false;
                this.isChildUpdate7=false;
            }else if (tab.name == "isChildUpdate7"){
                this.isChildUpdate7 = true;

                this.isChildUpdate1=false;
                this.isChildUpdate2=false;
                this.isChildUpdate3=false;
                this.isChildUpdate4=false;
                this.isChildUpdate5=false;
                this.isChildUpdate6=false;
                this.isChildUpdate8=false;
            }

        }
    },
    mounted(){
      window.jQuery(".el-container").find(".el-main").css({"height":window.innerHeight+"px","overflow":"hidden"});
      $(".el-aside").hide();
    }
  };
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .iframe .el-main{
  padding: 0px !important;
}

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 8px;
}


/deep/ .el-main{
  padding: 0px !important;
}
    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }


</style>
